import CustomAlertStore from "./CustomAlertStoreClass";

export function uiAlert(message, type = "info") {
  CustomAlertStore.show(message, type);
}
